export enum ShipmentDimensionsFilterType {
  SUMMARY = 'summary',
  ALL_BUT_DUPLICATES = 'all_no_dups',
  ALL = 'all',
}
